export default "__VITE_ASSET__BM6VofFN__"